import React from 'react';
import { useState } from "react";
import Navbar from '../components/Navbar'
import HeroSection from '../components/HeroSection'
import Footer from '../components/Footer'
import Schemes from '../components/Schemes.jsx';
import OfficerCard from "../components/OfficerCard.jsx";
import "../styles/Home.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaLandmark, FaTree, FaStar } from "react-icons/fa";


import officer1 from "../components/img/officers/2.jpg";
import officer2 from "../components/img/officers/1.jpg";
import officer3 from "../components/img/officers/MLA.jpg";
function Home() {
  const settings = {
  slidesToShow: 1, // Adjust to fit content
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  speed: 3000,
  autoplaySpeed: 4000,
  cssEase: "linear",
  arrows: false
};

  const [activeTab, setActiveTab] = useState("Recruitments");
  
  const tabs = ["What's New", "Tenders"];
  const whatsNewList = [
    "National Health Mission - Advertisement and Notice on Contractual Posts dated 26/03/2025 Corrigendum",
    "10 National Health Mission - Interim Eligible List for Contractual Posts Recruitment (as on January 17, 2024) - Psychologist",
    "9 National Health Mission - Interim Eligible List for Contractual Posts Recruitment (as on January 17, 2024) - Dental Hygienist",
    "8 National Health Mission - Interim Eligible List for Contractual Posts Recruitment (as on January 17, 2024) - Data Entry Operator",
    "7 National Health Mission - Interim Eligible List for Contractual Posts Recruitment (as on January 17, 2024) - District Program Manager AYUSH",
  ];
  const Tenders = [ "Works Department Zillha Parishad Buldhana Tender Notice No 25"  ]
  const Recruitments =[
    "National Health Mission- Advertisement and Notice on Contractual Posts dated 26/03/2025 Corrigendum",
    "10 National Health Mission – Interim Eligible List for Contractual Posts Recruitment (as on January 17, 2024) – Psychologist",
    "9 National Health Mission – Interim Eligible List for Contractual Posts Recruitment (as on January 17, 2024) – Dental Hygienist",
    "8 National Health Mission – Interim Eligible List for Contractual Posts Recruitment (as on January 17, 2024) – Data Entry Operator",
    "7 National Health Mission – Interim Eligible List for Contractual Posts Recruitment (as on January 17, 2024) – District Program Manager AYUSH"
  ]


  const officers = [
 
    {
      image: officer3,
      name: "Dr. Shri Sanjay Kute",
      position: "MLA",
    },
    {
      image: officer1,
      name: "Sandip More",
      position: "Block Developement Officer",
    },
    {
      image: officer2,
      name: "Ravindra Ingle",
      position: "Administrative Officer Jalgaon J",
    },
  ];
  const newsItems = [
    "Works Department Panchayat Samiti Jalgaon J Tender Notice 06/02/2025(chain-link-ps-jalgaon-ja.pdf)",
    "Works Department Panchayat Samiti Jalgaon J Tender Notice 06/02/2025(s-r-ladies-toilet-p-s-jalgaon.pdf)",
    "Works Department Panchayat Samiti Jalgaon J Tender Notice 06/02/2025(chain-link-ps-jalgaon-j.pdf)",
  ];
  
  const extractPdfDetails = (text) => {
    const match = text.match(/\((.*?)\)/); // Extract text inside ()
    if (match) {
      return {
        displayText: text.replace(match[0], "(PDF)"), // Replace filename with (PDF)
        pdfFileName: match[1], // Extracted PDF file name
      };
    }
    return { displayText: text, pdfFileName: null };
  };
  

  const tourismData = [
    { icon: <FaLandmark />, label: "Historic", },
    { icon: <FaTree />, label: "Natural / Scenic beauty", },
    { icon: <FaStar />, label: "Religious",},
  ];


  const destinations = [
    {
      title: "Rajmata Maa Jijau Birthplace, Sindkhed Raja",
      image: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/202412271925293879-qz4i0nma65sgkza93pxrbfh7bqxza5vz7lqxa6kdqw.jpg",
      description: "Jijamata, (Rajmata Maa Jijau) was born on 12 January in 1598, at Sindhkhedra in Buldhana district. Rajmata Jijau was the Matoshree of Chhatrapati Shivaji Maharaj, the founder of the Hinduvi empire.Today this place is not only a historical place but [...]",
    },
    {
      title: "Ambabarva Wild Life Sanctuary",
      image: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/20241227281530700-qz4c4vlccxvqrswkqoes1ddh3gru1654feblquklnc.jpg",
      description: "Ambabarwa has been known as a place of cool air since the British period. It has been declared as a sanctuary by the Government of Maharashtra. On the way to Ambabarwala, there are many scenic spots like Badarzara, Pimpalkhed, Chinchkhadi. [...]",
    },
    {
      title: "Shri Sant Gajanan Maharaj Temple Shegaon",
      image: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/202412271505774289-qz4ff2sprxosqj7nj9qv31l6as6gyydzofmpahbd7c.jpg",
      description:"On 23rd February, 1878 on Magh Vaidya Saptami, Shri Sant Gajanan Maharaj appeared under a grand banyan tree near Paturkar’s palace. Sri.Gajanan Maharaj Sansthan established Pragatsthala Vastu in front of this ancient banyan tree where this perfect and bright form [...]"
    },
    {
      title: "Lonar Lake",
      image: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/202412272128319126-qz4iqanslgw1a21hdsxebyjuo4kf8xoe2idqjwjs0o.jpg",
      description:"Lonar Lake is a notified National Geo-heritage Monument saline soda lake located at Lonar in Buldhana district, Maharashtra, India, which was created by a meteor impact during the Pleistocene Epoch and it is the only known hyper velocity impact crater [...]"
    },
  ];

  const events = [
    {
      title: "Rajmata Mahotsav 2025 – Grand Exhibition and Sale...",
      date: "February 28, 2025",
      description:
        "Rajmata Mahotsav 2025 – Grand Exhibition and Sale of Rural Creativity of Divisional, District and Mini Saras",
      image: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/20250228256179662-r25yw3g71kvfh88os5spbjfjbq7kph1lnbmc1iahm6.jpeg",
    },
    {
      title: "Zilla Parishad Buldhana Sports and Cultural Events 2025",
      date: "February 9, 2025",
      description:
        "Zilla Parishad Buldhana Sports and Cultural Events 2025",
      image: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/202502071646583692-r15w9dd740nlnm9z6eihdf78xgkwzgwpopxk3e21f2.jpg",
    },
  ];

  const departments = [
    "General Administration Department",
    "Village Panchayat Department",
    "Education Department (Secondary)",
    "Agriculture Department",
    "Works Department",
    "Minor Irrigation",
    "Social Welfare Department",
    "Finance Department",
    "Education Department (Primary)",
    "Health Department",
    "ICDS",
    "Rural Water Supply",
    "District Rural Development Agency",
    "Animal Husbandry Department",
  ];
  return (
    <div className='home-container'>
        <Navbar/>
        <HeroSection/>
        <section className="news">
  <h4 className="news-title">Latest News</h4>
  <div className='news-bar'/>
  <div className="news-slider">
    <Slider {...settings}>
      {newsItems.map((item, index) => {
        const { displayText, pdfFileName } = extractPdfDetails(item);
        return (
          <div key={index} className="news-item">
            <a
              href={`/pdfs/${pdfFileName}`} 
              download
              className="pdf-link"
            >
              {displayText}
            </a>
            <span className="latest-news">New</span>
          </div>
        );
      })}
    </Slider>
  </div>
</section>;
  <div className="news-bottom"/>
        <div className="container">
      {/* Introduction Section */}
      <div className="intro-section">
        <h2>Introduction</h2>
        <p>
        Jalgaon jamod is located in the buldhana district Amravati division of Maharashtra, India. It is situated at the western border of Vidarbha region and is 600 km away from the state capital, Mumbai.under the taluka it has 45 villages and famous for the beauty of nature & well known as a satpuda parvat.
        </p>
        <button className="read-more">Read More</button>
      </div>
      
      {/* Tabs Section */}
      <div className="tabs-section">
        <div className="tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={activeTab === tab ? "active-tab" : "tab"}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="tab-content">
          {activeTab === "What's New" && (
            <ul>
              {whatsNewList.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          )}

            {activeTab === "Tenders" && (
            <ul>
              {Tenders.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          )}

          {activeTab === "Recruitments" && (
            <ul>
              {Recruitments.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          )}
        </div>
        <button className="read-more">View all</button>
      </div>
      
      {/* Officer Card */}
      <div className="officers">
      
      <div className="officer-cards-container">
          {officers.map((officer, index) => (
            <OfficerCard
              key={index}
              image={officer.image}
              name={officer.name}
              position={officer.position}
            />
          ))}
        </div>
      </div>
    </div>
    <div className="tourism-section">
      <h2>Tourism</h2>
      <div className="tourism-container">
        {tourismData.map((item, index) => (
          <a key={index} href={item.link} className="tourism-card">
            <div className="icon">{item.icon}</div>
            <p>{item.label}</p>
          </a>
        ))}
      </div>
    </div>


    <div className="top-destination-container">
      <h2>Top Destination</h2>
      <div className="destinations">
        {destinations.map((item, index) => (
          <div key={index} className="destination-card">
            <img src={item.image} alt={item.title} />
            <div className="destination-title">{item.title}</div>
            <div className="destination-desc">{item.description}</div>
          </div>
        ))}
      </div>

      <div className="events-departments">
        <div className="events">
          <h3>Latest Upcoming Events</h3>
          {events.map((event, index) => (
            <div key={index} className="event-card">
              <img src={event.image} alt={event.title} />
              <div>
                <h4>{event.title}</h4>
                <p>{event.date}</p>
                <p>{event.description}</p>
              </div>
            </div>
          ))}
          <button className="view-all-btn">View All</button>
        </div>

        <div className="departments">
          <h3>Departments of Zilla Parishad</h3>
          <ul>
            {departments.map((dept, index) => (
              <li key={index}>{dept}</li>
            ))}
          </ul>
          <button className="view-all-btn">View All</button>
        </div>
      </div>
    </div>

      <Schemes/>
     
        <Footer/>

    </div>
  )
}

export default Home